'use client';

import { motion } from 'motion/react';
import LogoSpinner from './LogoSpinner';

export default function LoadingSpinner() {
  return (
    <div className="fixed inset-0 bg-white dark:bg-slate-900 flex flex-col items-center justify-center z-50">
      <LogoSpinner size={96} />
      <motion.p
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="text-gray-600 dark:text-slate-300 font-medium mt-8"
      >
        Loading PopFrame...
      </motion.p>
    </div>
  );
}
